export const COGNITO_STORAGE_KEY = "fd_cognito_session";

export function clearCognitoSession(): void {
  localStorage.removeItem(COGNITO_STORAGE_KEY);
  sessionStorage.removeItem(COGNITO_STORAGE_KEY);
  sessionStorage.removeItem("fd_cognito_pkce");
}
